import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, isRef as _isRef, withKeys as _withKeys, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { ref, watch } from 'vue';
export default {
    __name: 'Serach',
    props: {
        loadData: {
            type: Function,
            default: ()=>{}
        },
        pageSize: {
            type: Number,
            default: 12
        },
        value: {
            type: String,
            default: ''
        }
    },
    emits: [
        'update:search'
    ],
    setup (__props, { emit: __emit }) {
        let search = ref(__props.value);
        // Emitujemy zdarzenie 'update:modelValue' w przypadku zmiany wartości
        const emit = __emit;
        // Funkcja do emisji zmiany w 'search' do rodzica
        const updateSearch = (event)=>{
            emit('update:search', event) // Emitujemy nową wartość do rodzica
            ;
        };
        watch(()=>__props.value, (newVal)=>{
            search.value = newVal;
        });
        return (_ctx, _cache)=>{
            const _component_el_input = _resolveComponent("el-input");
            return _openBlock(), _createBlock(_component_el_input, {
                modelValue: _unref(search),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>_isRef(search) ? search.value = $event : search = $event),
                placeholder: "Szukaj",
                onInput: updateSearch,
                onKeyup: _cache[1] || (_cache[1] = _withKeys(($event)=>__props.loadData(__props.pageSize), [
                    "enter"
                ]))
            }, {
                prefix: _withCtx(()=>_cache[2] || (_cache[2] = [
                        _createElementVNode("i", {
                            class: "icon novum-icon-search"
                        }, null, -1)
                    ])),
                _: 1
            }, 8, [
                "modelValue"
            ]);
        };
    }
};
